(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/store/order-home-context.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/store/order-home-context.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  createContext = _React.createContext,
  useCallback = _React.useCallback,
  useContext = _React.useContext,
  useReducer = _React.useReducer,
  useEffect = _React.useEffect;
const OrderHomeContext = createContext();
const useLocalStorage = svs.ticketsOrderHome.hooks.useLocalStorage;
const ORDER_HOME_STATE_KEY = 'orderTickets';
const ORDER_HOME_STATE_DOMAIN = 'tickets-order-home';
const ORDER_HOME_STATE_EXPIRATION = svs.components.Storage.constants.EXPIRES_15M;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils.constants,
  SHIPPING_COST = _svs$ticketsOrderHome.SHIPPING_COST,
  MINIMUM_TOTAL_ORDER_PRICE = _svs$ticketsOrderHome.MINIMUM_TOTAL_ORDER_PRICE;
const isMaximumQuantityWeightReachedForTicket = svs.ticketsOrderHome.utils.isMaximumQuantityWeightReachedForTicket;
const buildCart = tickets => {
  const totalOrderCount = tickets.reduce((acc, ticket) => acc + ticket.count, 0);
  const totalOrderPrice = tickets.reduce((acc, ticket) => acc + ticket.count * ticket.price, totalOrderCount > 0 ? SHIPPING_COST : 0);
  const minimumTotalOrderPriceNotReached = totalOrderPrice < MINIMUM_TOTAL_ORDER_PRICE;
  const cartTickets = tickets.map(ticket => _objectSpread(_objectSpread({}, ticket), {}, {
    totalPrice: ticket.count * ticket.price,
    incrementDisabled: isMaximumQuantityWeightReachedForTicket(ticket, tickets),
    decrementDisabled: ticket.count <= 0
  })).filter(ticket => ticket.count > 0);
  return {
    tickets: cartTickets,
    totalOrderCount,
    totalOrderPrice,
    minimumTotalOrderPriceNotReached,
    shippingCost: SHIPPING_COST
  };
};
const createInitialState = function () {
  var _greetings$;
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$tickets = _ref.tickets,
    savedOrderTickets = _ref$tickets === void 0 ? [] : _ref$tickets,
    _ref$receiver = _ref.receiver,
    receiver = _ref$receiver === void 0 ? {
      other: false,
      search: {},
      details: {}
    } : _ref$receiver,
    _ref$personalGreeting = _ref.personalGreeting,
    personalGreeting = _ref$personalGreeting === void 0 ? '' : _ref$personalGreeting,
    _ref$greetingMessage = _ref.greetingMessage,
    greetingMessage = _ref$greetingMessage === void 0 ? '' : _ref$greetingMessage;
  const availableTickets = svs.ticketsOrderHome.data.config.orderHome.tickets.filter(ticket => ticket.available).map(ticket => _objectSpread({}, ticket));
  const greetings = svs.ticketsOrderHome.data.config.orderHome.orderHomeMessage.greetings;
  const tickets = availableTickets.map(ticket => {
    var _savedOrderTickets$fi;
    return {
      id: ticket.id,
      count: ((_savedOrderTickets$fi = savedOrderTickets.find(_ref2 => {
        let id = _ref2.id;
        return id === ticket.id;
      })) === null || _savedOrderTickets$fi === void 0 ? void 0 : _savedOrderTickets$fi.count) || 0,
      price: ticket.price,
      name: ticket.name,
      image: _objectSpread({}, ticket.image)
    };
  });
  personalGreeting = personalGreeting || (greetings === null || greetings === void 0 || (_greetings$ = greetings[0]) === null || _greetings$ === void 0 ? void 0 : _greetings$.personalGreetingInput) || '';
  const cart = buildCart(tickets);
  return {
    availableTickets,
    tickets,
    cart,
    order: {},
    receiver,
    personalGreeting,
    greetingMessage
  };
};
const reducer = (state, action) => {
  let tickets;
  switch (action.type) {
    case 'INCREMENT_ORDER_COUNT':
      tickets = state.tickets.map(ticket => {
        if (ticket.id === action.payload.id) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            count: ticket.count + 1
          });
        }
        return ticket;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        tickets,
        cart: buildCart(tickets)
      });
    case 'DECREMENT_ORDER_COUNT':
      tickets = state.tickets.map(ticket => {
        if (ticket.id === action.payload.id) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            count: ticket.count - 1
          });
        }
        return ticket;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        tickets,
        cart: buildCart(tickets)
      });
    case 'SET_ORDER_COUNT':
      tickets = state.tickets.map(ticket => {
        if (ticket.id === action.payload.id) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            count: action.payload.count
          });
        }
        return ticket;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        tickets,
        cart: buildCart(tickets)
      });
    case 'SET_ORDER':
      return _objectSpread(_objectSpread({}, state), {}, {
        order: _objectSpread({}, action.payload)
      });
    case 'SET_RECEIVER':
      return _objectSpread(_objectSpread({}, state), {}, {
        receiver: action.payload
      });
    case 'SET_RECEIVER_SEARCH_RESULT':
      return _objectSpread(_objectSpread({}, state), {}, {
        receiver: _objectSpread(_objectSpread({}, state.receiver), {}, {
          results: _objectSpread(_objectSpread({}, state.receiver.results), {}, {
            [action.payload.searchCacheKey]: action.payload.searchResult
          }),
          result: action.payload.searchResult.result
        })
      });
    case 'SET_PERSONAL_GREETING_INPUT':
      return _objectSpread(_objectSpread({}, state), {}, {
        personalGreeting: action.payload
      });
    case 'SET_GREETING_INPUT':
      return _objectSpread(_objectSpread({}, state), {}, {
        greetingMessage: action.payload
      });
    case 'RESET_STATE':
      return createInitialState();
    default:
      return state;
  }
};
const OrderHomeProvider = _ref3 => {
  let children = _ref3.children;
  const _useLocalStorage = useLocalStorage(ORDER_HOME_STATE_KEY, ORDER_HOME_STATE_DOMAIN, [], ORDER_HOME_STATE_EXPIRATION),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    savedOrder = _useLocalStorage2[0],
    setSavedOrder = _useLocalStorage2[1];
  const _useReducer = useReducer(reducer, savedOrder, createInitialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(() => {
    setSavedOrder({
      tickets: state.tickets.map(_ref4 => {
        let id = _ref4.id,
          count = _ref4.count;
        return {
          id,
          count
        };
      }),
      receiver: state.receiver,
      personalGreeting: state.personalGreeting,
      greetingMessage: state.greetingMessage
    });
  }, [state, setSavedOrder]);
  const incrementOrderCount = useCallback(id => {
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartTicketCountChange(id, 1);
    dispatch({
      type: 'INCREMENT_ORDER_COUNT',
      payload: {
        id
      }
    });
  }, []);
  const decrementOrderCount = useCallback(id => {
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartTicketCountChange(id, -1);
    dispatch({
      type: 'DECREMENT_ORDER_COUNT',
      payload: {
        id
      }
    });
  }, []);
  const setOrderCount = useCallback((id, count) => {
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartTicketCountChange(id, count);
    dispatch({
      type: 'SET_ORDER_COUNT',
      payload: {
        id,
        count
      }
    });
  }, []);
  const setOrder = useCallback(_ref5 => {
    let orderItems = _ref5.orderItems,
      referenceId = _ref5.referenceId,
      _ref5$giftAddress = _ref5.giftAddress,
      giftAddress = _ref5$giftAddress === void 0 ? null : _ref5$giftAddress,
      _ref5$isGift = _ref5.isGift,
      isGift = _ref5$isGift === void 0 ? false : _ref5$isGift;
    dispatch({
      type: 'SET_ORDER',
      payload: {
        orderItems,
        referenceId,
        giftAddress,
        isGift
      }
    });
  }, []);
  const setReceiver = useCallback(receiver => {
    dispatch({
      type: 'SET_RECEIVER',
      payload: receiver
    });
  }, []);
  const setReceiverSearchResult = useCallback((searchCacheKey, searchResult) => {
    dispatch({
      type: 'SET_RECEIVER_SEARCH_RESULT',
      payload: {
        searchCacheKey,
        searchResult
      }
    });
  }, []);
  const setPersonalGreetingInput = greeting => {
    dispatch({
      type: 'SET_PERSONAL_GREETING_INPUT',
      payload: greeting
    });
  };
  const setGreetingInput = message => {
    dispatch({
      type: 'SET_GREETING_INPUT',
      payload: message
    });
  };
  const resetState = useCallback(() => {
    dispatch({
      type: 'RESET_STATE'
    });
  }, []);
  return React.createElement(OrderHomeContext.Provider, {
    value: {
      state,
      incrementOrderCount,
      decrementOrderCount,
      setOrderCount,
      setOrder,
      setReceiver,
      setReceiverSearchResult,
      resetState,
      setPersonalGreetingInput,
      setGreetingInput
    }
  }, children);
};
const useOrderHomeContext = () => useContext(OrderHomeContext);
setGlobal('svs.ticketsOrderHome.context', {
  OrderHomeContext,
  OrderHomeProvider,
  useOrderHomeContext
});

 })(window);